import sharedoSettings from "@/services/sharedo/sharedoSettingsService";

const openWorkItem = id => {
    const baseUrl = sharedoSettings.get().sharedoApi;
    const command = `{"command":"openSharedo","params":{"id":"${id}"}}`
    return `${baseUrl}?ui-cmd=${encodeURIComponent(command)}`
}

const openDocumentTemplate = systemName => {
    const baseUrl = sharedoSettings.get().sharedoApi;
    const command = `{"command":"openDocumentTemplate","params":{"systemName":"${systemName}"}}`
    return `${baseUrl}?ui-cmd=${encodeURIComponent(command)}`
}

const openExpressionHelp = () => {
    const baseUrl = sharedoSettings.get().sharedoApi;
    const command = `{"command":"openExpressionHelp","params":{}}`
    return `${baseUrl}?ui-cmd=${encodeURIComponent(command)}`
}

const openHelpPage = name => `${window.location.origin}/#/help/${name}`;

const openLogPage = () => `${window.location.origin}/#/diagnostics/log`;

const openLegacyBrowserPage = () => `${window.location.origin}/#/ie-support`;

export {
    openWorkItem,
    openDocumentTemplate,
    openExpressionHelp,
    openHelpPage,
    openLogPage,
    openLegacyBrowserPage
}

export default {
    openWorkItem,
    openDocumentTemplate,
    openExpressionHelp,
    openHelpPage,
    openLegacyBrowserPage
}